import { productConstants } from '@eti/products';
import type { ExtraProduct, SellSpecificationTravelerChoiceNew } from '@eti/schema-types';
import type { OrderTypePostbooking } from './OrderUtils';

const extraProducts = {
  ...productConstants,
};

const isSellSpecificationTravelerChoiceNew = (
  sellSpec: ExtraProduct['sellSpecification'],
): sellSpec is SellSpecificationTravelerChoiceNew => {
  return sellSpec?.__typename === 'SellSpecificationTravelerChoiceNew';
};

export const getSimpleVisaProduct = (order: OrderTypePostbooking) => {
  if (!order || !order.availableExtraProducts) {
    return null;
  }

  return (
    order?.availableExtraProducts?.find(
      (product) => String(product.id) === String(extraProducts.SIMPLE_VISA.id),
    ) || null
  );
};

export const getSimpleVisaInitialValues = (order: OrderTypePostbooking) => {
  const simpleVisa = getSimpleVisaProduct(order);

  if (simpleVisa) {
    const availableChoices = isSellSpecificationTravelerChoiceNew(simpleVisa?.sellSpecification)
      ? simpleVisa.sellSpecification?.availableChoices
      : undefined;

    const preSelectedChoices = isSellSpecificationTravelerChoiceNew(simpleVisa?.sellSpecification)
      ? simpleVisa.sellSpecification?.preselectedChoice
      : undefined;

    return {
      simpleVisa: {
        travelers: extraProducts.SIMPLE_VISA.simpleVisaTransformer.getPreselectedTravelerChoices(
          order.travelers,
          availableChoices,
          preSelectedChoices,
        ),
      },
    };
  }

  return {};
};
